import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { receiveKeys } from './keys';

import type { TypeGetInboundRequestProgressParams, TypeGetInboundRequestProgressResponse } from '~/types/receive.types';

const fetchInboundRequestProgress = async (
  ownerCode: string,
  params: TypeGetInboundRequestProgressParams
): Promise<TypeGetInboundRequestProgressResponse> => {
  const { data } = await axiosInstance.get<TypeGetInboundRequestProgressResponse>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/inbound-request/progress`,
    { params }
  );
  return data;
};

type TypeUseGetInboundRequestProgressQueryParams = {
  ownerCode: string;
  params: TypeGetInboundRequestProgressParams;
  enabled?: boolean;
};

/**
 * [입고관리 > 입고현황] 3PL 입고현황 목록 조회 Query Hook
 */
export const useGetInboundRequestProgressQuery = ({
  ownerCode,
  params,
  enabled = true,
}: TypeUseGetInboundRequestProgressQueryParams) => {
  return useQuery({
    queryKey: receiveKeys.inboundRequestProgress(ownerCode, params),
    queryFn: () => fetchInboundRequestProgress(ownerCode, params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
